import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { subtractPeriod } from 'utils/utils';
import isAdmin from 'utils/session/isAdmin';
import api from 'utils/api';
import { playlistQueryKeys } from '.';
export default function useFetchRecentPlaylistUsers(_ref) {
  var contentId = _ref.contentId,
    showOnlyInactiveUsers = _ref.showOnlyInactiveUsers;
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var q;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            q = {
              fields: ['completionRate', 'updated_time', {
                collectionAsset: ['name', 'id'],
                users: ['name', 'id', 'first_name', 'last_name']
              }],
              filter: {
                collection_id: contentId,
                '-completion_rate': null,
                updated_time: showOnlyInactiveUsers ? "..".concat(format(subtractPeriod('month') || new Date(), 'yyyy-MM-dd')) : undefined
              },
              orderby: 'updated_time DESC',
              limit: 25
            };
            return _context.abrupt("return", api('get', '/api/query/userCollections', q).then(function (resp) {
              return resp.items;
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var _useQuery = useQuery({
      queryFn: queryFn,
      queryKey: playlistQueryKeys.recentPlaylistUser(contentId, showOnlyInactiveUsers),
      enabled: isAdmin()
    }),
    data = _useQuery.data,
    isLoading = _useQuery.isLoading,
    isError = _useQuery.isError;
  return {
    items: data || [],
    isLoading: isLoading,
    isError: isError
  };
}